var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pdf"},[_c('div',{staticClass:"pdf-back van-hairline--bottom"},[_c('van-icon',{staticClass:"pdf-back-icon",attrs:{"name":"arrow-left"},on:{"click":_vm.goBack}}),_c('span',[_vm._v("报告详情")])],1),_c('pdfPreview',{attrs:{"url":_vm.pdfUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }